import { CMS_QUERIES } from '@/constants/content-stack'
import { AppDependencyUnrecoverableError } from '@/errors/classes/AppDependencyUnrecoverableError'
import { ErrorCode } from '@/errors/classes/ErrorCode'

export const getCmsQuery = (error: ErrorCode) => {
  if (
    error instanceof AppDependencyUnrecoverableError &&
    error.errorCodeType === 'PRINTER_NOT_SUPPORTED'
  )
    return [CMS_QUERIES.ERROR.CATEGORY.PRINTER_NOT_SUPPORTED]

  return [CMS_QUERIES.ERROR.CATEGORY.DEFAULT]
}
